export const asistencialRoutes = [
  {
    path: '/asistenciales',
    name: 'Asistencial',
    component: () =>
      import(
        /* webpackChunkName: "asistencial" */ '@/modules/Core/views/Index.vue'
      ),
    icon: 'mdiStethoscope',
    typeIcon: 'mdi',
    menu: true,
    desplegable: true,
    meta: {
      title: 'Asistencial',
      requiresSession: true,
      permiso: [],
      perfiles: [
        'VACUNACION',
        'CONSULTA EXTERNA',
        'PROCEDIMIENTOS',
        'LABORATORIOS',
        'COORDINADOR ASISTENCIAL',
        'OTROS SERVICIOS'
      ]
    },
    children: [
      {
        path: '/asistenciales/Consulta',
        name: 'AsistencialConIndex',
        desplegable: false,
        icon: 'mdiFolderMultiplePlus',
        typeIcon: 'mdi',
        menu: true,
        replace: true,
        meta: {
          permiso: ['tramitarConsulta', 'trarmitarPreConsulta'],
          perfiles: [
            'CONSULTA EXTERNA',
            'COORDINADOR ASISTENCIAL',
            'PRECONSULTA'
          ],
          title: 'Consulta ext.',
          subTitle: 'Consultas externas',
          requiresSession: true,
          showBackButton: false
        },
        children: [],
        component: () =>
          import(
            /* webpackChunkName: "asistencial" */ '@/modules/Asistencial/views/Asistencial/Consulta/ConsultationIndex.vue'
          )
      },
      {
        path: '/asistenciales/Consulta/View/:id',
        name: 'AsistencialConView',
        desplegable: false,
        icon: 'mdiFolderMultiplePlus',
        typeIcon: 'mdi',
        menu: false,
        replace: true,
        meta: {
          perfiles: ['CONSULTA EXTERNA', 'COORDINADOR ASISTENCIAL', 'ADMISIONES'],
          title: 'Consulta ext.',
          requiresSession: true,
          showBackButton: false
        },
        children: [],
        component: () =>
          import(
            /* webpackChunkName: "asistencial" */ '@/modules/Asistencial/views/Asistencial/Consulta/ConsultationView.vue'
          )
      },
      {
        path: '/asistenciales/Consulta/Create/:id',
        name: 'Historia',
        component: () =>
          import(
            /* webpackChunkName: "asistencial" */ '@/modules/Asistencial/views/Asistencial/Consulta/ConsultationForm.vue'
          ),
        icon: '',
        menu: false,
        desplegable: false,
        meta: {
          forceRemount: true,
          title: 'Historia clínica',
          requiresSession: true,
          perfiles: ['CONSULTA EXTERNA', 'COORDINADOR ASISTENCIAL'],
          isSticky: true
        },
        children: []
      },
      {
        path: '/asistenciales/Vacuna',
        name: 'AsistencialVacunacion',
        desplegable: false,
        icon: 'mdiNeedle',
        typeIcon: 'mdi',
        menu: true,
        meta: {
          permiso: [],
          title: 'Vacunacion',
          perfiles: ['VACUNACION', 'COORDINADOR ASISTENCIAL'],
          subTitle: 'Lista de vacunaciones',
          requiresSession: true,
          showBackButton: false
        },
        children: [],
        component: () =>
          import(
            /* webpackChunkName: "asistencial" */ '@/modules/Asistencial/views/Asistencial/Vacunacion/VacunacionIndex.vue'
          )
      },
      {
        path: '/asistenciales/Vacuna/View/:id',
        name: 'AsistencialVacunacionView',
        desplegable: false,
        icon: 'mdiNeedle',
        typeIcon: 'mdi',
        menu: false,
        meta: {
          permiso: [],
          title: 'Vacunacion',
          perfiles: ['VACUNACION', 'COORDINADOR ASISTENCIAL'],
          requiresSession: true,
          showBackButton: false
        },
        children: [],
        component: () =>
          import(
            /* webpackChunkName: "asistencial" */ '@/modules/Asistencial/views/Asistencial/Vacunacion/VacunacionView.vue'
          )
      },
      {
        path: '/asistenciales/Procedimiento',
        name: 'AsistencialProIndex',
        desplegable: false,
        icon: 'mdiAccountHeartOutline',
        typeIcon: 'mdi',
        menu: true,
        meta: {
          permiso: [],
          perfiles: ['PROCEDIMIENTOS', 'COORDINADOR ASISTENCIAL'],
          title: 'Procedimientos',
          subTitle: 'Lista de procedimientos',
          requiresSession: true,
          showBackButton: false
        },
        children: [],
        component: () =>
          import(
            /* webpackChunkName: "asistencial" */ '@/modules/Asistencial/views/Asistencial/Procedimiento/ProcedimientoIndex.vue'
          )
      },
      {
        path: '/asistenciales/Procedimiento/View/:id',
        name: 'AsistencialProView',
        desplegable: false,
        icon: 'mdiAccountHeartOutline',
        typeIcon: 'mdi',
        menu: false,
        meta: {
          permiso: [],
          perfiles: ['ADMISIONES', 'PROCEDIMIENTOS', 'COORDINADOR ASISTENCIAL'],
          title: 'Procedimientos',
          requiresSession: true,
          showBackButton: false
        },
        children: [],
        component: () =>
          import(
            /* webpackChunkName: "asistencial" */ '@/modules/Asistencial/views/Asistencial/Procedimiento/ProcedimientoView.vue'
          )
      },
      {
        path: '/asistenciales/Procedimiento/Create/:id',
        name: 'AsistencialProCreate',
        component: () =>
          import(
            /* webpackChunkName: "asistencial" */ '@/modules/Asistencial/views/Asistencial/Procedimiento/ProcedimientoForm.vue'
          ),
        icon: '',
        menu: false,
        desplegable: false,
        meta: {
          title: 'PROCEDIMIENTOS',
          requiresSession: true,
          permiso: []
        },
        children: []
      },
      {
        path: '/asistenciales/Laboratorio',
        name: 'AsistencialLabIndex',
        desplegable: false,
        icon: 'mdiFlaskOutline',
        typeIcon: 'mdi',
        menu: true,
        meta: {
          permiso: [],
          perfiles: ['LABORATORIOS', 'COORDINADOR ASISTENCIAL'],
          title: 'Laboratorios',
          subTitle: 'Lista de laboratorios',
          requiresSession: true,
          showBackButton: false
        },
        children: [],
        component: () =>
          import(
            /* webpackChunkName: "asistencial" */ '@/modules/Asistencial/views/Asistencial/Laboratorio/LaboratorioIndex.vue'
          )
      },
      {
        path: '/asistenciales/Laboratorio/View/:id',
        name: 'AsistencialLabView',
        desplegable: false,
        icon: 'mdiFlaskOutline',
        typeIcon: 'mdi',
        menu: false,
        meta: {
          permiso: [],
          perfiles: ['LABORATORIOS', 'COORDINADOR ASISTENCIAL', 'ADMISIONES'],
          title: 'Laboratorios',
          requiresSession: true
        },
        children: [],
        component: () =>
          import(
            /* webpackChunkName: "asistencial" */ '@/modules/Asistencial/views/Asistencial/Laboratorio/LaboratorioPanel.vue'
          )
      },
      {
        path: '/asistenciales/OtrosServicios',
        name: 'AsistencialOTSIndex',
        desplegable: false,
        icon: 'mdiNewspaperVariantMultipleOutline',
        typeIcon: 'mdi',
        menu: true,
        meta: {
          permiso: [],
          perfiles: ['OTROS SERVICIOS', 'COORDINADOR ASISTENCIAL'],
          title: 'Otros Servicios',
          subTitle: 'Lista de otros servicios',
          requiresSession: true,
          showBackButton: false
        },
        children: [],
        component: () =>
          import(
            /* webpackChunkName: "asistencial" */ '@/modules/Asistencial/views/Asistencial/OtrosServicios/OtrosServiciosIndex.vue'
          )
      },
      {
        path: '/asistenciales/OtrosServicios/View/:id',
        name: 'AsistencialOTSView',
        desplegable: false,
        icon: 'mdiAccountHeartOutline',
        typeIcon: 'mdi',
        menu: false,
        meta: {
          permiso: [],
          perfiles: [
            'ADMISIONES',
            'OTROS SERVICIOS',
            'COORDINADOR ASISTENCIAL'
          ],
          title: 'OTROS SERVICIOS',
          requiresSession: true,
          showBackButton: false
        },
        children: [],
        component: () =>
          import(
            /* webpackChunkName: "asistencial" */ '@/modules/Asistencial/views/Asistencial/OtrosServicios/OtrosServiciosView.vue'
          )
      },
      {
        path: '/asistenciales/OtrosServicios/Create/:id',
        name: 'AsistencialOTSCreate',
        component: () =>
          import(
            /* webpackChunkName: "asistencial" */ '@/modules/Asistencial/views/Asistencial/OtrosServicios/OtrosServiciosForm.vue'
          ),
        icon: '',
        menu: false,
        desplegable: false,
        meta: {
          title: 'OTROS SERVICIOS',
          requiresSession: true,
          permiso: []
        },
        children: []
      }
    ]
  }
]
